

































import { Component, Vue } from "vue-property-decorator";
import { readEntries } from "@/store/uniabc/getters";

@Component
export default class GlobalReferenceList extends Vue {
  private headers = [
    { text: "Label", value: "label" },
    { text: "Term", value: "term_de" },
    { text: "Section", value: "section" }
  ];

  private entries = readEntries(this.$store);
  private entrySearch = "";

  get entriesList() {
    return Object.keys(this.entries).map((e: string) => this.entries[e]);
  }
}
